import { ForwardedRef, forwardRef, HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { ScrollbarPropsType, Scrollbars } from "../../../Scrollbars";

import styles from "./styles.module.scss";

export type SideoutMenuChildrenProps = HTMLAttributes<HTMLDivElement> & {
  contentClassName?: string;
  scrollable?: boolean;
  scrollBarProps?: ScrollbarPropsType;
  containerProps?: HTMLAttributes<HTMLDivElement>;
};

export const SideoutMenuChildren = memo(
  forwardRef(
    (
      {
        scrollable = true,
        children,
        contentClassName,
        scrollBarProps,
        containerProps,
        ...restProps
      }: SideoutMenuChildrenProps,
      ref: ForwardedRef<HTMLDivElement>,
    ) => {
      const content = (
        <div
          {...restProps}
          className={classNames(styles.childrenContainer, restProps.className)}
          ref={ref}
        >
          {children}
        </div>
      );

      return scrollable ? (
        <Scrollbars
          className={classNames(
            styles.childrenWrapper,
            contentClassName,
            "os-host-flexbox",
          )}
          {...scrollBarProps}
        >
          {content}
        </Scrollbars>
      ) : (
        <div
          className={classNames(styles.childrenWrapper, contentClassName)}
          {...containerProps}
        >
          {content}
        </div>
      );

    },
  ),
);
